import NavigationBar from "../../../navigation/nav-bar/navigationBar";
import FooterComponent from "../../../navigation/footer/footerComponent";
import PrimaryIntensiveBody from "./primaryIntensiveBody";

export default function MainPrimaryIntensiveComponent() {

    return (
        <div>
            <NavigationBar />
            <PrimaryIntensiveBody />
            <FooterComponent />
        </div>
    )
}